import React from "react";
import "./ContactSection.css";

const ContactSection = () => {
  return (
    <>
      {/* ================================
          PAGE BANNER
      ================================= */}
    
     
<section className="page-banner">
      <div className="page-banner-container">
        <h2>
          Contact Us
        </h2>
      </div>
    </section>

      {/* ================================
          CONTACT SECTION
      ================================= */}
      <section
        className="contact-area-2 garud-contact-section"
        id="contact-sec"
      >
        <div className="container">

          {/* Section Heading */}
          <div className="title-area text-center garud-title-area">
            <span className="garud-section-label">
              GET IN TOUCH
            </span>

            <h2 className="sec-title">
              Let&apos;s Plan Your Journey
            </h2>

            <p className="garud-contact-intro">
              Have a question, need a cab, or want to plan an
              outstation trip? Reach out to Garud Cab Service.
              Our team will be happy to assist you.
            </p>
          </div>

          {/* Contact Cards */}
          <div className="row gy-4 justify-content-center">

            {/* Phone */}
            <div className="col-xl-4 col-lg-4 col-md-6">
              <div className="garud-contact-card">

                <div className="garud-icon-wrap">
                  <i className="fa-solid fa-phone"></i>
                </div>

                <div className="media-body">

                  <p className="garud-card-label">
                    Call Us
                  </p>

                  <h3 className="garud-card-title">
                    Speak With Our Team
                  </h3>

                  <a
                    href="tel:+919970007784"
                    className="garud-contact-link"
                  >
                    +91 9970007784
                  </a>

                  <a
                    href="tel:+919970353709"
                    className="garud-contact-link"
                  >
                    +91 9970353709
                  </a>

                  <span className="garud-card-note">
                    Available for cab bookings & enquiries
                  </span>

                </div>
              </div>
            </div>

            {/* Email */}
            <div className="col-xl-4 col-lg-4 col-md-6">
              <div className="garud-contact-card">

                <div className="garud-icon-wrap">
                  <i className="fa-solid fa-envelope"></i>
                </div>

                <div className="media-body">

                  <p className="garud-card-label">
                    Email Us
                  </p>

                  <h3 className="garud-card-title">
                    Send Your Enquiry
                  </h3>

                  <a
                    href="mailto:booking@garudcabs.com"
                    className="garud-contact-link"
                  >
                    booking@garudcabs.com
                  </a>

                  <span className="garud-card-note">
                    Send us your travel requirements
                  </span>

                </div>
              </div>
            </div>

            {/* Address */}
            <div className="col-xl-4 col-lg-4 col-md-6">
              <div className="garud-contact-card">

                <div className="garud-icon-wrap">
                  <i className="fa-solid fa-location-dot"></i>
                </div>

                <div className="media-body">

                  <p className="garud-card-label">
                    Visit Us
                  </p>

                  <h3 className="garud-card-title">
                    Our Office
                  </h3>

                  <span className="garud-address">
                    Garud Cab Service
                    <br />
                    Office No.101 Anand Heights
                 Chandan Nagar, Kharadi, Pune,
                 Maharashtra, India-  411014 
                  </span>

                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ================================
          MAP SECTION
      ================================= */}
      <section className="garud-map-section">

        <div className="container-fluid p-0">

          <div className="garud-map-heading">
            <span>
              <i className="fa-solid fa-location-dot"></i>
            </span>

            <div>
              <small>FIND US</small>
              <h3>Our Location</h3>
            </div>
          </div>

         
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d92193.03626174961!2d73.78907203674318!3d18.561482861162517!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c15fbd7697a5%3A0x8e30fc921edd2023!2sGarudcabs%20%7C%20Best%20Cab%20Service%20in%20Pune!5e1!3m2!1sen!2sin!4v1787111736295!5m2!1sen!2sin" width="100%"
            height="450" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>

        </div>
      </section>
    </>
  );
};

export default ContactSection;
